import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { TLocale } from 'store/features/application/types/locale';
import enLocale from '../locales/en';

type IntlProviderProps = React.ComponentProps<typeof IntlProvider>;
type TMessages = IntlProviderProps['messages'];

type TUseGetTranslates = (currentLocale: TLocale) => TMessages;

const useGetTranslates: TUseGetTranslates = (locale) => {
  const [messages, setMessages] = useState({ ...enLocale });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await import(`../locales/${locale}.ts`);
        setMessages({ ...enLocale, ...data.default });
      } catch (e) {
        console.info(e);
      }
    };
    fetchData();
  }, [setMessages, locale]);

  return messages;
};

export default useGetTranslates;
